// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","idea":"_1yuk1R2Hw__Gb0B1F4cG0y","researchCard":"_2DJKUhPKC93NBn7481EkI","heading":"_1TeSLp3p6iYUfUVHdvNqJL","reorderForm":"hIEEb0FcgItNHvTzqJxFi"};